<template>
    <div class="table-tools-actions flex justify-center md:justify-end w-full items-center space-x-2 select-none pr-4">
      <base-button-responsive @click="toggleSearchesDialog" size="xs" class="w-full md:w-auto" icon='search' :text="$tc('app.search', 2)" :disabled="disabled"></base-button-responsive>
    </div>
</template>

<script>
export default {
  name: 'base-table-searches',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      search: ''
    }
  },
  methods: {
    toggleSearchesDialog: function () {
      this.$emit('toggleSearchesDialog')
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
